import { css } from 'glamor'
import * as PropTypes from 'prop-types'
import * as React from 'react'

import { useTheme } from '../../theme'

import { AnimateChildHeight } from '../animate-child-height'
import { Flex } from '../flex'
import { Touchable } from '../touchable'
import { ChevronIcon } from '../chevron-icon'

import getStyles from './styles'

interface IAccordionItemProps {
  children?: React.ReactNode
  title?: React.ReactNode
  card?: boolean
}

export const AccordionItem: React.FC<IAccordionItemProps> = props => {
  const styles = getStyles(useTheme())
  const [isOpen, setOpen] = React.useState(false)

  return (
    <>
      <Flex
        {...css(
          styles.accordionItem.base,
          props.card && styles.accordionItem.card,
          props.card && isOpen && styles.accordionItem.cardOpen
        )}
      >
        <Touchable
          alignItems="center"
          flexDirection={props.card ? 'row-reverse' : 'row'}
          justifyContent={props.card ? 'flex-end' : 'space-between'}
          onClick={() => setOpen(value => !value)}
        >
          <Flex marginLeft={props.card ? 'small' : undefined}>{props.title}</Flex>
          <ChevronIcon direction={props.card ? (isOpen ? 'down' : 'right') : isOpen ? 'up' : 'down'} />
        </Touchable>
      </Flex>
      <AnimateChildHeight>
        {isOpen && (
          <Flex {...css(styles.accordionItemContent.base, props.card && styles.accordionItemContent.card)}>
            {props.children}
          </Flex>
        )}
      </AnimateChildHeight>
    </>
  )
}

AccordionItem.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  card: PropTypes.bool,
}

interface IAccordionProps {
  children?: React.ReactNode
  flush?: boolean
  card?: boolean
}

export const Accordion: React.FC<IAccordionProps> = props => {
  const styles = getStyles(useTheme())

  return (
    <Flex {...css(styles.accordion.base, props.flush && styles.accordion.flush, props.card && styles.accordion.card)}>
      {props.children}
    </Flex>
  )
}

Accordion.propTypes = {
  children: PropTypes.node,
  flush: PropTypes.bool,
  card: PropTypes.bool,
}
